import { expandAnimation } from '@shared/common/animations/expandAnimation';
import { ChangeDetectionStrategy, Component, Directive, EventEmitter, HostBinding, Input, Output } from '@angular/core';

type CardColour = 'white' | 'tonal' | 'purple' | 'tonal-purple' | 'tonal-red'

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [expandAnimation()],
})
export class CardComponent {
    @Input() color: CardColour;
    @Output() headerClick = new EventEmitter<MouseEvent>();
    @Output() headerDoubleClick = new EventEmitter<MouseEvent>();
    @Output() headerContextMenu = new EventEmitter<MouseEvent>();
    @Input() elevation: number | 'popover';
    @Input() showContent = true;
    @Input() showHeader = true;
    @Input() animateContent = false;

    @HostBinding('class')
    get ngClass() {
        const classes = {};

        if (this.elevation) {
            classes[`elevation-${this.elevation}`] = true;
        }

        if (this.color) {
            classes[`app-card-colour-${this.color}`] = true;
        }

        return classes;
    }
}


// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: 'app-card-title' })
export class CardTitleDirective {

}

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: 'app-card-subtitle' })
export class CardSubtitleDirective {

}

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: 'app-card-header-actions' })
export class CardHeaderActionsDirective {

}

// eslint-disable-next-line @angular-eslint/directive-selector
@Component({
    selector: 'app-card-actions',
    template: `
        <div class="app-card-actions__start">
            <ng-content select="[appCardActionsStart]"></ng-content>
        </div>

        <ng-content></ng-content>
    `
})
export class CardActionsComponent {

}
